import { createSlice } from '@reduxjs/toolkit';

const initialState: { [key: string]: { isVisible: boolean | null } } = {};

const evaluacionVisibleStateSlice = createSlice({
	name: 'evaluacionVisibleState',
	initialState,
	reducers: {
		setEvaluacionVisiblelState: (state, action) => {
			const evaluacionVisibleState = action.payload;
			return { ...state, ...evaluacionVisibleState };
		}
	}
});

export const { setEvaluacionVisiblelState } = evaluacionVisibleStateSlice.actions;

export default evaluacionVisibleStateSlice.reducer;
